const paths: Array<[string, string]> = [
	['/manage-account', 'ManageAccount'],
	['/manage-bank-account', 'BankAccounts'],
	['/ira-close-account', 'IraCloseAccountModal'],
	['/account-settings', 'AccountSettings'],
	['/plan-details', 'SubscriptionDetails'],
	['/manage-subscription', 'ManageSubscription'],
	['/security', 'Security'],
	['/documents', 'Documents'],
	['/tax-documents', 'TaxDocuments'],
	['/statements', 'Statements'],
	['/trade-confirmations', 'TradeConfirmations'],
	[
		'/fully-paid-securities-lending-confirmations',
		'FullyPaidSecuritiesLendingConfirmations',
	],
	['/activity', 'Activity'],
	['/investments_lending', 'SecuritiesLending'],
	['/promotion-code', 'PromotionCode'],
	['/notification-settings', 'NotificationContainer'],
	['/notifications', 'NotificationCenterRoute'],
	['/notification-center', 'NotificationCenterRoute'],
	['/investor-profile', 'InvestorProfileRoute'],
	['/cancel-stash/:screen?', 'CloseAccountContainer'],
	['/dividend-reinvestment-program', 'Drip'],
	['/change-billing-frequency', 'BillingFrequencyChooser'],
	['/data-sharing', 'DataSharing'],
	['/add-payment-method', 'PaymentMethodOptions'],
];

export default paths;
